<!--台账设备树组件-->
<template>
	<div class="readDeviceTreeBody">
		<tree :imgMethod="imgMethod" :menuCheckedAble='true' :nowOpenFloorIds="nowOpenFloorIds" :dataList="dataList" :getEnableMethod="getEnableMethod" :getNameMethod="getNameMethod" :getIdMethod="getIdMethod" :nowCheckId="nowCheckId" @checkItem="checkItem"></tree>
	</div>
</template>

<script>
	import tree from './tree.vue'
	import enumStore from '../../../cache/enumStore.js'
	import resourcesStore from '@/cache/resourcesStore.js'	
	export default {
		components: {
			tree
		},
		props: [],
		data() {
			return {
				nowCheckId: '',
				nowCheckItem: {},
				nowOpenFloorIds: []
			}
		},
		created() {
		},
		mounted() {
			//加载以后默认选中第一个设备
			var interval = setInterval(() => {
				if(isempty(this.dataList)) {
					return
				}
				this.checkFirst(this.dataList)
				clearInterval(interval)
			}, 500)
		},
		destroyed() {},
		computed: {
			dataList() {
				return enumStore.getters.getEnumTree
			},
		},
		watch: {
			dataList(nv, ov) {
				if(isempty(ov)) {
					this.checkFirst(nv)
				}
			},
			nowCheckItem(nv, ov) {
				this.$emit("checkItem", nv)
			}
		},
		methods: {
			checkFirst(dataList) {
				//递归打开层级直到找到第一个设备
				var obj = this.findDevice(dataList)
				this.nowOpenFloorIds = obj.floor
				this.nowCheckId = this.getIdMethod(obj.device)
				this.nowCheckItem = obj.device
			},
			isSame(item,now){
				if(isempty(now) ||isempty(item)){
					return false
				}
				return  item.entityName==now.entityName && item.id ==now.id
			},
			imgMethod(item) {
				if(isempty(this.nowCheckItem) || !this.isSame(item,this.nowCheckItem)) {//item.type == "enum"||
						return resourcesStore.getters.getResourcesByName('tree/node_class.png')//,'tree/node_class_select.png'
				}else{
					return resourcesStore.getters.getResourcesByName('tree/node_class_select.png')
				}
			},
			getIdMethod(item) {
				if(item.entityName == "AppEnum") {
					return item.enumcode
				}
				return ''
			},
			getNameMethod(item) {
				if(item.entityName == "AppEnum") {
					return item.enumname
				}
				return item.itemtext
			},
			checkItem(item) {
				this.nowCheckId = this.getIdMethod(item)
				this.nowCheckItem = item
			},
			findDevice(dataList) {
				var list = []
				for(var i = 0, len = dataList.length; i < len; i++) {
					var item = dataList[i]
					if(item.entityName == 'AppEnum') {
						return {
							device: item,
							floor: [this.getIdMethod(item)]
						}
					} else if(!isempty(item.next)) {
						//找一下下级
						var obj = this.findDevice(item.next)
						if(obj != undefined) {
							//找到了,把自己的id也加进去
							obj.floor.push(this.getIdMethod(item))
							return obj
						}
					}
				}
			},
			getEnableMethod(item){
				return item.entityName == 'AppEnum'
			}
		}
	}
</script>

<style scoped>
	.readDeviceTreeBody {
		height: 100%;
		overflow: auto;
	}
</style>